import { React } from 'react';

import Header from './components/Header';
import Footer from './components/Footer';
import Routing from './components/Routes';

import './App.css';

import { LanguageSelector } from "./components/LanguageSwitcher";

const App = () => {

  return (
    <>
        
        <Header />
        <LanguageSelector />
        <main id="app">
          <Routing />
        </main>
        <Footer />

    </>
  );
}

export default App;